
import { useParams } from 'react-router-dom';
import { ModelosFormState } from '../../../context/modelos/ModelosFormState';
import { Form } from './form';

export const ModelosFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Modelo":"Crear Modelo";
  
  return (
    <ModelosFormState>
        <br />
        <Form title={title} />
    </ModelosFormState>
  );
};
